// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"70":"e13d01bb","262":"30c9fb71","475":"1a8d2edc","619":"2f3e7e44","802":"61772b31"}[chunkId] + ".chunk.css";
};